import { useDrilldownSchema } from 'features/drilldown'
import { DrilldownFieldType } from 'features/drilldown/rolodex/ontology/ontologyTypes'
import { useMemo } from 'react'

interface UseFieldTypeProps {
  isEditingCustomProperty: boolean
  customPropertyType: DrilldownFieldType
  selectedField: string
}

export const useFieldType = ({
  isEditingCustomProperty,
  customPropertyType,
  selectedField,
}: UseFieldTypeProps): DrilldownFieldType => {
  const { fields } = useDrilldownSchema()

  return useMemo((): DrilldownFieldType => {
    if (isEditingCustomProperty) return customPropertyType
    if (!selectedField) return 'text'
    return (fields[selectedField]?.fieldType as DrilldownFieldType) || 'text'
  }, [isEditingCustomProperty, customPropertyType, selectedField, fields])
}
